// Static headshot pool — one URL per car number.
// IndyCar FullBody CDN for drivers that have them; Wikimedia Commons fallback for others.
const IC = 'https://www.indycar.com/-/media/IndyCar/Drivers/IndyCar-Series/FullBody'
const WM = 'https://upload.wikimedia.org/wikipedia/commons'

export const DRIVER_PHOTOS: Record<number, string> = {
  2:  `${IC}/JosefNewgarden.png`,
  3:  `${IC}/ScottMcLaughlin.png`,
  4:  `${IC}/CaioCollet.png`,
  5:  `${IC}/PatoOWard.png`,
  6:  `${IC}/HelioCastroneves.png`,
  7:  `${IC}/ChristianLundgaard.png`,
  8:  `${IC}/KyffinSimpson.png`,
  9:  `${IC}/ScottDixon.png`,
  10: `${IC}/AlexPalou.png`,
  11: `${IC}/KatherineLegge.png`,
  12: `${IC}/DavidMalukas.png`,
  14: `${IC}/SantinoFerrucci.png`,
  15: `${IC}/GrahamRahal.png`,
  18: `${IC}/RomainGrosjean.png`,
  19: `${IC}/DennisHauger.png`,
  20: `${IC}/AlexanderRossi.png`,
  21: `${IC}/ChristianRasmussen.png`,
  23: `${IC}/ConorDaly.png`,
  24: `${IC}/JackHarvey.png`,
  26: `${IC}/WillPower.png`,
  27: `${IC}/KyleKirkwood.png`,
  28: `${IC}/MarcusEricsson.png`,
  31: `${IC}/RyanHunterReay.png`,
  33: `${IC}/EdCarpenter.png`,
  45: `${IC}/LouisFoster.png`,
  47: `${IC}/MickSchumacher.png`,
  51: `${IC}/JacobAbel.png`,
  60: `${IC}/FelixRosenqvist.png`,
  66: `${IC}/MarcusArmstrong.png`,
  75: `${IC}/TakumaSato.png`,
  76: `${IC}/RinusVeeKay.png`,
  77: `${IC}/StingRayRobb.png`,
}

export const BORG_WARNER_TROPHY = '/images/borg-warner-trophy.jpg'
